/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAIUnitEconomicsCost extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAIUnitEconomicsCost");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAIUnitEconomicsCost.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAIUnitEconomicsCost>): BackgroundJobPayloadForPeriodicAIUnitEconomicsCost {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAIUnitEconomicsCost(), model);
        BackgroundJobPayloadForPeriodicAIUnitEconomicsCost.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAIUnitEconomicsCost>): BackgroundJobPayloadForPeriodicAIUnitEconomicsCost {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAIUnitEconomicsCost.newInstance(<BackgroundJobPayloadForPeriodicAIUnitEconomicsCost> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAIUnitEconomicsCost) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAIUnitEconomicsCost.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAIUnitEconomicsCost): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAIUnitEconomicsCost.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
